import { render, staticRenderFns } from "./ProductBatchBasicTable.vue?vue&type=template&id=0dc08a52&"
import script from "./ProductBatchBasicTable.vue?vue&type=script&lang=js&"
export * from "./ProductBatchBasicTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductBatchBasicTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports